import React from 'react';

import { Spin } from 'antd';

import QuickView from 'v2/components/Shared/QuickView';
import type { ShoppingDelivery } from 'v2/interfaces/shopping';

import Info from './infoProduct';
import JobProduct from './jobProduct';
import PhysicalProduct from './physicalProduct';
import Ticket from './ticketProduct';

interface ProductQuickviewProps {
  open: boolean;
  delivery: ShoppingDelivery;
  onClose: () => void;
  closeQuickView: () => void;
}

const ProductQuickview = ({ open, delivery, onClose, closeQuickView }: ProductQuickviewProps) => {
  return (
    <QuickView
      title={
        <span>
          {delivery?.product.type} ({delivery?.product.id})
        </span>
      }
      open={open}
      onClose={onClose}
    >
      {delivery ? (
        <div className='flex flex-col gap-2'>
          {delivery.product.type === 'Infoproduto' && <Info delivery={delivery} closeQuickView={closeQuickView} />}

          {delivery.product.type === 'Produto físico' && <PhysicalProduct delivery={delivery} />}

          {delivery.product.type === 'Serviço' && <JobProduct delivery={delivery} closeQuickView={closeQuickView} />}

          {delivery.product.type === 'Ticket' && <Ticket delivery={delivery} closeQuickView={closeQuickView} />}
        </div>
      ) : (
        <Spin />
      )}
    </QuickView>
  );
};

export default ProductQuickview;
